import { applyLandingBrand } from "@/lib/siteHosts"

export const aboutContent = applyLandingBrand({
  eyebrow: "ABOUT THE RESEARCHERS",
  title: "Not Built in Silicon Valley. Built on Job Sites.",
  body: "We co-own roofing operations. We conducted this {count}-company nationwide audit because we were tired of paying Google and Meta for leads, only to lose them to faster competitors while on site.",
})
